import { takeEvery, call, put, select, all } from 'redux-saga/effects';
import {
  initState as initRequestStatusState,
  requestInProcess,
  requestFinished,
  setCodeResponse
} from '../../../../common/reducers/_requestStatus/reducer';
import {
  initState as initStateFormErrors,
  setErrors,
  clearErrors
} from '../../../../common/reducers/_formErrors/reducer';
import { sendForm, initState } from './actions';
import { selectFormBody } from './selectors';
import { timeoutCall } from '../../../../utils/sagaHalper';
import CouponsService from '../../services';
import * as clientNoticesActions from '../../../main/reducers/static/states/clientNotices/reducer';

function* createPayment(reducerName) {
  const formBody = yield select(selectFormBody, reducerName);
  yield put(requestInProcess(reducerName));
  try {
    yield put(clearErrors(reducerName));
    const response = yield call(
      timeoutCall,
      CouponsService.activatedCoupon,
      formBody
    );
    if (response) {
      if (response.status === 200) {
        if (response.data.message) {
          yield put(
            clientNoticesActions.addClientNotice({
              type: 'success',
              message: response.data.message
            })
          );
        }
      } else if (response.status === 422) {
        yield put(setErrors(reducerName, response.data));
      }
      yield put(setCodeResponse(reducerName, response.status));
    }
  } catch (error) {
    console.log(error);
  }
  yield put(requestFinished(reducerName));
}

function* initStates(reducerName) {
  yield put(initRequestStatusState(reducerName));
  yield put(initStateFormErrors(reducerName));
}

export default function* createSaga(reducerName) {
  yield all([
    takeEvery(sendForm(reducerName).type, createPayment, reducerName),
    takeEvery(initState(reducerName).type, initStates, reducerName)
  ]);
}



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/coupons/reducers/activatedCouponForm/saga.js